<template>
  <v-card
    v-if="notEmptyArray(dataArr)"
    class="rounded-0"
    flat
  >
    <v-card-title
      v-if="title"
      class="text-center justify-center pt-5 pb-2 title-text"
      :style="{ 'color': appColor.textDark }"
    >
      {{ title }}
    </v-card-title>
    <v-simple-table>
      <template #default>
        <thead>
          <tr>
            <th class="header-cell" />
            <th class="header-cell" />
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="item in dataArr"
            :key="item.key"
          >
            <td
              class="left-cell"
              :style="{ 'color': appColor.textDark }"
            >
              {{ item.key }}
            </td>
            <td
              v-if="notEmptyArray(item.value)"
              class="text-left right-cell"
              :style="{ 'color': appColor.textDark }"
            >
              <ul class="right-cell__list">
                <li
                  v-for="string in item.value"
                  :key="string"
                >
                  {{ string }}
                </li>
              </ul>
            </td>
            <td
              v-else
              class="text-right right-cell"
              :style="{ 'color': (item.status && appColor.success) || (item.status === false && appColor.error) || appColor.textDark }"
            >
              {{ item.value }}
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </v-card>
</template>

<script>
import { isArray } from '@/helpers/helpers'

export default {
  name: 'ResultTable',

  props: {
    dataArr: {
      type: Array,
      require: true,
      default: null
    },
    title: {
      type: String,
      require: false,
      default: ''
    }
  },

  data () {
    return {
      appColor: this.$appConfig.color
    }
  },

  methods: {
    notEmptyArray (arr) {
      return isArray(arr)
    }
  }
}
</script>

<style lang="scss" scoped>
  .header-cell {
    border-bottom: none !important;
    height: 0 !important;
  }

  .title-text {
    font-size: 1rem;

    @media(max-width: $cp-mobile-breakpoint) {
      font-size: 0.9rem;
    }
  }

  .left-cell {
    max-width: 50%;

    @media(max-width: $cp-mobile-breakpoint) {
      font-size: 0.7rem !important;
    }
  }

  .right-cell {
    width: max-content;
    min-width: 50%;
    max-width: 80%;
    word-break: break-word;

    &__list {
      min-width: 30vw;

      @media(max-width: $cp-mobile-breakpoint) {
        width: 60vw;
      }
    }

    @media(max-width: $cp-mobile-breakpoint) {
      font-size: 0.7rem !important;
    }
  }

  .text-success {
    color: $color-success;
  }

  .text-error {
    color: $color-error;
  }
</style>
